import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useCoverageOptionRateLogic = () => {
  const apiRoute = "coverageoptionrates";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "coverage_option",
      label: "Coverage option",
      type: "dropdown",
      isRequired: true,
      err: "Coverage option is required",
      returnID: true,
      disableEditForNonAdmin: true,
    },
    {
      name: "season",
      label: "Season",
      type: "dropdown",
      isRequired: true,
      err: "Season is required",
      returnID: true,
      disableEditForNonAdmin: true,
    },
    {
      name: "currency",
      label: "Currency",
      type: "dropdown",
      isRequired: false,
      err: "Currency is required",
      disabled: true,
      returnID: true,
      placeholder: "Season's branch currency",
      disableEditForNonAdmin: true,
    },
    {
      name: "class",
      label: "Category",
      type: "dropdown",
      isRequired: true,
      err: "Category is required",
      returnID: true,
      disableEditForNonAdmin: true,
    },
    {
      name: "daily_rate",
      label: "Daily rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Daily rate is required",
    },
    {
      name: "weekly_rate",
      label: "Weekly rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Weekly rate is required",
    },
    {
      name: "monthly_rate",
      label: "Monthly rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Monthly rate is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(
        config,
        "coverageoptions",
        "coverage_option",
        temp
      ),
      fetchDataAndMapToField(config, "seasons", "season", temp, "Name"),
      fetchDataAndMapToField(
        config,
        "currencies",
        "currency",
        temp,
        "code",
        "symbol"
      ),
      fetchDataAndMapToField(config, "vehicleclasses", "class", temp, "name"),
    ];
  };

  return {
    apiRoute,
    onlyForm,
    initFields,
    addRoles,
    deleteRoles,
    editRoles,
    getPromises,
  };
};

export default useCoverageOptionRateLogic;
